import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import AOS from 'aos'
import { SITE,ROUTES } from '@/constants'
import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import MetaInfo from '@common/MetaInfo'
import { useScrollSpy } from '@helpers/useIntersectionObserver'
import TransformBanner from '@sections/TransformBanner'
import { useTypewriter } from '../assets/js/common'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.OUR_LEGACY)

// ── Know Us — paragraph content ───────────────────────────────────────
const KNOW_US_PARAGRAPHS = [
  <>CruxBytes Consultancy Services is more than a decade old proprietorship firm founded by <a href="#" className="about-inline-link">Vikiraj Hinger</a> in 2010 at Mumbai. He himself comes with a Degree in Computer Science from VJTI (Mumbai) and has strong expertise working in companies like Infosys and IRIS Business.</>,
  'We specialize in core software development related services, including, but not limited to, Web app/mobile app development, Product Development, quality assurance, consulting services for IT automation as per business needs, cloud server hosting, DevOps, Technical maintenance, support, digital marketing, SEO and related activities.',
  'Under a single banner we offer various services such as Software development, Customized Application development, Application Maintenance, Application Support, Web services, Website designing, Web Hosting, DNS Management, Email Server Management, GoogleApps account setup and Management, Logo Designing, Data Migration, Quality Assurance & Testing, Product Development, Specialized services such as Search Engine Analysis & Optimization, Social Media Integration, Analytics for Website etc.',
]

// ── Strengths — pill tags ─────────────────────────────────────────────
const STRENGTHS_PILLS = [
  'PHP', '.NET', 'React.js', 'Flutter', 'HTML5',
  'MS SQL', 'MySQL', 'Postgres', 'MongoDB', 'Crystal Reports',
]

// ── Team — stat + pills ───────────────────────────────────────────────
const TEAM_STAT = { value: '300M+', label: 'Electricity consumers served via UJALA' }
const TEAM_PILLS = ['UJALA', 'Vidyut Pravah', 'Merit India', 'PRAAPTI']

// ── Milestones — add more objects to grow the timeline ────────────────
const MILESTONES = [
  {
    year: '2010',
    title: 'CruxBytes Founded',
    desc: 'Vikiraj Hinger founded CruxBytes from a small family godown backyard, a home PC, a friend and lots of good wishes from family and trustworthy network.',
  },
  {
    year: '2011',
    title: 'First Enterprise Client',
    desc: 'Delivered 1st full scale B2C web application on a global healthcare platform.',
  },
  {
    year: '2012',
    title: 'Deep dive into FinTech',
    desc: 'Enabled client to launch India’s fully automated income tax filing platform, stock advisory platform and similar other apps.',
  },
  {
    year: '2014',
    title: 'Ministry of Power Partnership',
    desc: 'Pioneered automation of Central Government’s public Schemes such as UJALA',
  },
  {
    year: '2015',
    title: 'UJALA Dashboard Launched for MoP',
    desc: 'Ideated and delivered one of the first real-time dashboards in the Ministry of Power, tracking the landmark UJALA LED scheme across India. Proud display of Ujala dashboard (client: EESL) on PMO office for realtime monitoring of the public distribution scheme.',
  },
  {
    year: '2018',
    title: '300 Million Consumers Served',
    desc: 'Our platforms collectively touched over 300 million electricity consumers, with Vidyut Pravah, MERIT, and PRAAPTI going live across the country.',
  },
  {
    year: '2019',
    title: 'CTO As A Service',
    desc: 'Partnered with startups to provide CTO services, successfully ideated and implemented a few product ideas around personal finance, crypto, mutual funds.',
  },
  {
    year: '2021',
    title: 'Product Development Team',
    desc: 'Embarked on a journey to deliver world class AI-enabled Oncology platform, setup a team of 20 AI Engineers, designers, doctors and QA specialist to evolve a full fledged IT team and sold the business later in 2024',
  },
  {
    year: '2024',
    title: 'AI Journey Begins',
    desc: 'Integrated AI-Native Development into development strategy for existing clients. Developed clinic automation tools, cloud services etc',
  },
  {
    year: '2026',
    title: 'Security Compliance Benchmarks',
    desc: 'Implemented security benchmarks for reputed PSU websites to ensure compliance with DPDP, GIGW, STQC and WCAG.',
  },
]





const TECH_BADGES = [
  { label: 'React',      icon: 'fa-brands fa-react',      color: '#61DAFB', top: '5%',  left: '68%'  },
  { label: 'Node.js',    icon: 'fa-brands fa-node-js',    color: '#539E43', top: '20%',  left: '82%'  },
  { label: 'Python',     icon: 'fa-brands fa-python',     color: '#3776AB', top: '62%',  left: '80%'  },
  { label: 'Flutter',    icon: 'fa-brands fa-flutter',    color: '#54C5F8', top: '72%',  left: '65%'  },
  { label: 'AWS',        icon: 'fa-brands fa-aws',        color: '#FF9900', top: '40%',  left: '5%'  },
]

/* ── Floating stat cards ── */
const STAT_CARDS = [
  { label: 'Years of Existance', value: '16+', top: '20%', left: '2%'  },
  { label: 'Projects Completed',    value: '200+',  top: '58%', left: '2%'  },
  { label: 'Satisfied Customers',    value: '99%',  top: '30%', left: '60%'  },
]

/* ── Avatar stack — dummy faces ── */
const AVATARS = [
  'https://i.pravatar.cc/80?u=lead1',
  'https://i.pravatar.cc/80?u=lead2',
  'https://i.pravatar.cc/80?u=lead3',
]
const ABOUT_DIFF = [
  { id: '1',      icon: 'fa-solid fa-star', label: 'Decades of Experience' },
  { id: '2',      icon: 'fa-regular fa-star', label: 'Rich Domain Expertise' },
  { id: '3',  icon: 'fa-regular fa-exclamation', label: 'In house Implementation Teams' },
  { id: '4', icon: 'fa-solid fa-diamond', label: 'Flexible Engagement Models' },
  { id: '5',   icon: 'fa-solid fa-check', label: 'Tailored Solutions' },
  { id: '6',    icon: 'fa-regular fa-check', label: 'Amazing Customer Service' },
  { id: '7',    icon: 'fa-solid fa-exclamation', label: 'Cost Effective Solutions' },
  { id: '8',    icon: 'fa-solid fa-triangle-exclamation', label: 'Go-To Team' },
]

// function useTypewriter(words) {
//   const [wordIndex, setWordIndex] = useState(0)
//   const [text, setText] = useState('')
//   const [phase, setPhase] = useState('typing') // 'typing' | 'pausing' | 'erasing' | 'waiting'

//   useEffect(() => {
//     const currentWord = words[wordIndex]
//     let timer

//     if (phase === 'typing') {
//       if (text.length < currentWord.length) {
//         timer = setTimeout(() => setText(currentWord.slice(0, text.length + 1)), TYPING_SPEED)
//       } else {
//         timer = setTimeout(() => setPhase('pausing'), PAUSE_AFTER_TYPE)
//       }
//     } else if (phase === 'pausing') {
//       timer = setTimeout(() => setPhase('erasing'), 0)
//     } else if (phase === 'erasing') {
//       if (text.length > 0) {
//         timer = setTimeout(() => setText(currentWord.slice(0, text.length - 1)), ERASING_SPEED)
//       } else {
//         timer = setTimeout(() => setPhase('waiting'), PAUSE_AFTER_ERASE)
//       }
//     } else if (phase === 'waiting') {
//       timer = setTimeout(() => {
//         setWordIndex(prev => (prev + 1) % words.length)
//         setPhase('typing')
//       }, 0)
//     }

//     return () => clearTimeout(timer)
//   }, [text, phase, wordIndex, words])

//   return text
// }
const TYPEWRITER_WORDS = ['AUSTRALIA','DUBAI', 'USA','INDIA']
// const TYPING_SPEED = 90      // ms per character while typing
// const ERASING_SPEED = 45     // ms per character while erasing
// const PAUSE_AFTER_TYPE = 1400 // ms to hold the full word before erasing
// const PAUSE_AFTER_ERASE = 400 // ms pause on empty string before next word starts
export default function AboutUsPage() {
  // useEffect(() => { AOS.refresh(); window.scrollTo(0, 0) }, [])
const typedWord = useTypewriter(TYPEWRITER_WORDS)
  return (
    <>
      {/* <MetaInfo
        title={`About Us | ${SITE.fullName}`}
        description="Meet the visionary leadership team behind CruxBytes driving innovation and excellence."
        keywords="CruxBytes leadership, technology leaders, CEO, CTO, management team"
      /> */}
 <MetaInfo
      title={label} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
        {/* <div className="page-hero">
        <div className="bg-grid bg-grid--fill" aria-hidden="true" />
        <div className="container">
          
           <Breadcrumb />
          <h1>About Us</h1>
          <p className="page-subtitle">
            Explore our legacy, goals, leaders, and the values inspiring us. We are building history with every passing moment !
          </p>
          <div className="inner-page-actions">
            <Button href={ROUTES.SALES_ENQUIRY} variant="primary" icon="fa-arrow-right" iconPos="right">
              Start a project
            </Button>           
          </div>
        </div>
      </div>  */}
        <section className="page-hero lp-section section-py ">
<div className="bg-grid bg-grid--fill" aria-hidden="true" />
          {/* Background grid — same as contact page */}
          {/* <div className="bg-grid bg-grid--fill" aria-hidden="true" /> */}

          <div className="container lp-grid">

            {/* ── LEFT: content ── */}
            <div className="lp-content" data-aos="fade-right">

              

              <h1 className="lp-heading">
                Since 2010!
              </h1>

              <p>CruxBytes is an AI-Native software development company headquartered in Mumbai, India since 2010, serving businesses globally across 
                  <span className="about-heading-typed">
                     {typedWord}<span className="about-typed-cursor" aria-hidden="true" />
                  </span>
              </p>
              <p>From startups to established enterprises, we help organizations streamline operations, automate business processes, and leverage technology to achieve sustainable growth.</p>
              <p><a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer"  aria-label="CruxBytes on LinkedIn" style={{textDecoration:'underline'}}>Vikiraj Hinger</a> is the Founder of CruxBytes. He is a software engineer - cum - finance geek having graduated from VJTI (Mumbai) in Computer Science and further pursued PGDBA in Finance from Symbiosis. He has a rich experience of working in companies like Infosys and FinTech company IRIS.</p>
          <p>We combine technical excellence with strategic thinking to deliver measurable business value.</p>

            

              {/* CTAs */}
              <div className="lp-actions">
                <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-paper-plane" iconPos="right">
                  Work With Us
                </Button>
                <Button href={ROUTES.OUR_WORK} variant="outline">
                  View Our Portfolio
                </Button>
              </div>

            </div>

            {/* ── RIGHT: visual ── */}
            <div className="lp-visual" data-aos="fade-left" aria-hidden="true">

              {/* Concentric rings */}
              <div className="lp-ring lp-ring--outer" />
              <div className="lp-ring lp-ring--inner" />

              {/* Blue filled circle */}
              <div className="lp-circle" />

              {/* Person photo — replace with transparent PNG when ready */}
              <img
                src="/assets/images/vikiraj-hinger.png"
                alt="Leadership"
                className="lp-person"
              />

              {/* Floating tech icon badges */}
              {TECH_BADGES.map((badge) => (
                <div
                  key={badge.label}
                  className="lp-tech-badge"
                  style={{ top: badge.top, left: badge.left }}
                >
                  <i className={badge.icon} style={{ color: badge.color }} />
                </div>
              ))}

              {/* Floating stat cards */}
              {STAT_CARDS.map((card) => (
                <div
                  key={card.label}
                  className="lp-stat-card"
                  style={{ top: card.top, left: card.left }}
                >
                  <span className="lp-stat-label">{card.label}</span>
                  <span className="lp-stat-value">{card.value}</span>
                </div>
              ))}

            </div>

          </div>
    
        </section>
                 {/* 2 ── Vision */}
             <section
               id="vision"
               className="about-us-section bg-linear-gradient-light text-center section-py"
               aria-labelledby="vision-heading"
               data-aos="fade-up"
               
             >
               {/* <span className="impact-eyebrow">Where We are Headed</span> */}               
               <p className="about-us-section-body section-px2" >
                 Our vision is not to be a large IT company by headcount. We would rather lead to be the best IT Services provider company providing quality and ethical deliveries globally and for a long term. So the customers can actually count on us to ensure their tech systems are up and running 365x24x7.
               </p>
               <h3 className='gradient-text' >“We Do IT Right, So You Can Do Business Better.”</h3>
             </section>
      
                    {/* 3 ── MileStones */}
             <section
               id="milestones"
               className="about-us-section  section-py section-px"
               aria-labelledby="milestones-heading"
               data-aos="fade-up"
               
             >
               {/* <span className="impact-eyebrow">Where We are Headed</span> */}
               <h2 id="milestones-heading text-center" className="section-heading text-center">Milestones</h2>
               <p className="about-us-section-body text-center">
                 A journey built on trust, innovation, and impact — here are the defining moments that shaped CruxBytes.
               </p>

               {/* ── Timeline ── */}
               <div className="ms-timeline container" aria-label="CruxBytes milestones">

                 {/* Vertical center line */}
                 <div className="ms-line" aria-hidden="true" />

                 {MILESTONES.map((item, idx) => {
                   const isRight = idx % 2 !== 0  // even = left, odd = right
                   return (
                     <div
                       key={item.year}
                       className={`ms-item${isRight ? ' ms-item--right' : ' ms-item--left'}`}
                       data-aos={isRight ? 'fade-left' : 'fade-right'}
                       data-aos-delay={idx * 80}
                     >
                       {/* Year badge — always on the center line */}
                       <div className="ms-year" aria-label={`Year ${item.year}`}>
                         {item.year}
                       </div>

                       {/* Content card */}
                       <div className="ms-card">
                         {/* Connector dot on the line side */}
                        <div className="ms-dot" aria-hidden="true" />
                         <h3 className="ms-card-title">{item.title}</h3>
                         <p className="ms-card-desc">{item.desc}</p>
                       </div>
                     </div>
                   )
                 })}

               </div>
             </section>
             <section className="bgs-section bgs-section--tint section-py" aria-labelledby="bgs-reach-heading">
      <div className="container">

        <div className="text-align-center" data-aos="fade-up">
          <h2 id="bgs-reach-heading">
           Our People
          </h2>
        </div>

       

        {/* Row 2 — Email marketing (text-only, no reference image) */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div className="bgs-row-content text-center">
          
            <p className='text-center text-white'>
              Our team members are the spine of our company’s growth. We offer a very positive work environment and growth opportunities. Our culture and values remain an integral part of our company’s growth story. Our alumni still cherish the time they spent at CruxBytes.
            </p>
            <Button  href={ROUTES.APPLY_FOR_JOB}  variant="primary" icon="fa-arrow-right" iconPos="right">Join Our Team</Button>
          </div>
        </div>

      </div>
    </section>
  
              {/* 4 ── Strengths */}
             <section
               id="strengths"
               className="about-us-section section-py container"
               aria-labelledby="strengths-heading"
               data-aos="fade-up"
             >
               {/* <span className="impact-eyebrow">What Sets Us Apart</span> */}
               <h2 id="strengths-heading" className="section-heading text-center">What differentiates us</h2>
               <h4 className="text-center text-italic">Delivering Technology. Enabling Businesses.</h4>
               <p className="about-us-section-bod text-center">
                 Your technology should work for your business, not become another challenge to manage. We provide proactive IT services that keep systems secure, operations smooth, and teams productive—stepping in wherever you need the expertise, support, or additional capacity.
               </p>
               <div className="about-diff-grid py-4" data-aos="fade-left">
                {ABOUT_DIFF.map(service => (
                  <div key={service.id} className="card card-diff-row card--rounded-xl about-diff-card">
                    <span className="icon-circle card-diff-icon">
                      <i className={service.icon} aria-hidden="true" />
                    </span>
                    <span>{service.label}</span>
                  </div>
                ))}
              </div>
             </section>
              {/* ── SPLIT SHOWCASE CARD ── */}
    
<TransformBanner />
      </main>
    </>
  )
}

// ── Page ──────────────────────────────────────────────────────────────
// export default function AboutUsPage() {
//   document.title = `Know Us | ${SITE.fullName}`

//   const location = useLocation()

//   useEffect(() => {
//     AOS.refresh()

//     if (location.hash) {
//       // Section elements render asynchronously — wait a tick so the target
//       // actually exists in the DOM before trying to scroll to it.
//       const id = location.hash.slice(1)
//       const timer = setTimeout(() => {
//         const el = document.getElementById(id)
//         if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
//       }, 150)
//       return () => clearTimeout(timer)
//     }

//     window.scrollTo(0, 0)
//   }, [location.hash])

//   const sectionIds = NAV_ITEMS.map(n => n.id)
//   // const activeId   = useScrollSpy(sectionIds)
//   const activeId   = useScrollSpy(sectionIds, { rootMargin: '-20% 0px -70% 0px' })

//   return (
//     <main id="main-content" className="page-wrapper">

//       {/* ── Hero ── */}
//       <div className="page-hero">
//         <div className="bg-grid bg-grid--fill" aria-hidden="true" />
//         <div className="container">
//           {/* <div className="section-label">- About Us -</div> */}
//            <Breadcrumb />
//           <h1>Know more about us</h1>
//           <p className="page-subtitle">
//             Dummy Projects we are proud of — from government portals to enterprise platform government portals to enterprise pla s.ls to enterprise platforms. proud of proud of from governm
//           </p>
         
//           <div className="inner-page-actions">
//             <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right">
//               Start a project
//             </Button>
//             <Button href={ROUTES.OUR_WORK} variant="outline" icon="fa-arrow-right" iconPos="right">
//               View our portfolio
//             </Button>
//           </div>
          
//         </div>
//       </div>

//       {/* ── Jump nav + sections ── */}
//       <div className="section-py about-us-content">
//         <div className="container about-us-layout">

//           {/* LEFT — sticky jump nav */}
//           <aside className="jumpnav-wrap">
//             <JumpNav activeId={activeId} />
//           </aside>

//           {/* RIGHT — scrollable sections */}
//           <div className="about-us-sections">

//             {/* 1 ── Know Us */}
//             <section
//               id="know-us"
//               className="about-us-section"
//               aria-labelledby="know-us-heading"
//               data-aos="fade-up"
//             >
//               {/* <span className="impact-eyebrow">Who We Are</span> */}
//               <h2 id="know-us-heading" className="section-heading">Know Us</h2>
//               {KNOW_US_PARAGRAPHS.map((para, i) => (
//                 <p key={i} className="about-us-section-body">{para}</p>
//               ))}
//             </section>

//             {/* 2 ── Vision */}
//             <section
//               id="vision"
//               className="about-us-section"
//               aria-labelledby="vision-heading"
//               data-aos="fade-up"
//             >
//               {/* <span className="impact-eyebrow">Where We are Headed</span> */}
//               <h2 id="vision-heading" className="section-heading">Vision</h2>
//               <p className="about-us-section-body">
//                 CruxBytes aims to become a leading IT company which is known for its unique, effective and out of the box solutions.
//               </p>
//             </section>

//             {/* 3 ── MileStones */}
//             <section
//               id="milestones"
//               className="about-us-section"
//               aria-labelledby="milestones-heading"
//               data-aos="fade-up"
//             >
//               {/* <span className="impact-eyebrow">Where We are Headed</span> */}
//               <h2 id="milestones-heading" className="section-heading">MileStones</h2>
//               <p className="about-us-section-body">
//                 A journey built on trust, innovation, and impact — here are the defining moments that shaped CruxBytes.
//               </p>

//               {/* ── Timeline ── */}
//               <div className="ms-timeline" aria-label="CruxBytes milestones">

//                 {/* Vertical center line */}
//                 <div className="ms-line" aria-hidden="true" />

//                 {MILESTONES.map((item, idx) => {
//                   const isRight = idx % 2 !== 0  // even = left, odd = right
//                   return (
//                     <div
//                       key={item.year}
//                       className={`ms-item${isRight ? ' ms-item--right' : ' ms-item--left'}`}
//                       data-aos={isRight ? 'fade-left' : 'fade-right'}
//                       data-aos-delay={idx * 80}
//                     >
//                       {/* Year badge — always on the center line */}
//                       <div className="ms-year" aria-label={`Year ${item.year}`}>
//                         {item.year}
//                       </div>

//                       {/* Content card */}
//                       <div className="ms-card">
//                         {/* Connector dot on the line side */}
//                         <div className="ms-dot" aria-hidden="true" />
//                         <h3 className="ms-card-title">{item.title}</h3>
//                         <p className="ms-card-desc">{item.desc}</p>
//                       </div>
//                     </div>
//                   )
//                 })}

//               </div>
//             </section>

//             {/* 4 ── Strengths */}
//             <section
//               id="strengths"
//               className="about-us-section"
//               aria-labelledby="strengths-heading"
//               data-aos="fade-up"
//             >
//               {/* <span className="impact-eyebrow">What Sets Us Apart</span> */}
//               <h2 id="strengths-heading" className="section-heading">Strengths</h2>
//               <p className="about-us-section-body">
//                 We believe that corporates today need a sound business analysis to arrive at a decision for selecting the right technology. We have a pool of experts specialized in analyzing the business requirements. Our technical expertise combined with sound analytical skills helps us to come up with cost-efficient solutions for our clients.
//               </p>
//               <p className="about-us-section-body">
//                 We have complete ability to cater to most of the IT requirements of any business entity. We strongly believe that technology is no-barrier for us as we have expertise in customized software application development on various technologies.
//               </p>
//               <div className="tech-pills about-us-pills">
//                 {STRENGTHS_PILLS.map(pill => (
//                   <span key={pill} className="tech-pill">{pill}</span>
//                 ))}
//               </div>
//             </section>

//             {/* 5 ── CruxBytes Team */}
//             <section
//               id="team"
//               className="about-us-section"
//               aria-labelledby="team-heading"
//               data-aos="fade-up"
//             >
//               {/* <span className="impact-eyebrow">Track Record</span> */}
//               <h2 id="team-heading" className="section-heading">CruxBytes Team</h2>
//               <p className="about-us-section-body">
//                 We have extensive experience on various industry verticals such as FinTech, HealthTech, Energy & Utilities, Retail and Education. Since 2014, we have worked extensively on various initiatives and social programmes which have been channelized by the Ministry of Power, the most important of them being UJALA LED Scheme (ujala.gov.in) driven by Shri Piyush Goyal from Ministry of Power where we effortlessly handled consumer transactions of more than 300 million electricity consumers.
//               </p>
//               <p className="about-us-section-body">
//                 Our inhouse technology experts have a deep expertise in creating realtime analytical and meaningful dashboards. UJALA dashboard, ideated by Vikiraj in 2015, was one of the first realtime dashboard in the Ministry and many further dashboards developed by various other agencies were modelled in similar fashion after that. We have also developed and implemented few more ideas from POSOCO and PFC Consulting limited which were a brain child of Ministry of power and they have revolutioned the way power exchange prices (vidyutpravah.in), thermal/renewable energy generation (meritindia.in) and billing (praapti.in) is being tracked today.
//               </p>
//               <div className="about-us-stat">
//                 <span className="impact-stat-value">{TEAM_STAT.value}</span>
//                 <span className="impact-stat-label">{TEAM_STAT.label}</span>
//               </div>
//               <div className="tech-pills about-us-pills">
//                 {TEAM_PILLS.map(pill => (
//                   <span key={pill} className="tech-pill">{pill}</span>
//                 ))}
//               </div>
//             </section>

//           </div>{/* end about-us-sections */}
//         </div>{/* end about-us-layout */}
//       </div>

//     </main>
//   )
// }